import { Theme, variantProvider, React, AppImages } from '@/app'
import {
  View,
  Link,
  Icon,
} from '@/components'

export const StoreButtons = (props) => (
  <View variants={['gap:2', 'marginVertical:2']} css={styles.storeButtonsWrapper} {...props}>
    <Link
      to={
        'https://apps.apple.com/gb/app/cherry-personalised-dating/id1673810759'
      }
    >
      <Icon name={'appStore'} style={styles.linkButton} />
    </Link>
    <Link
      to={
        'https://play.google.com/store/apps/details?id=uk.co.codeleap.cherry&hl=en_US'
      }
    >
      <Icon name={'googlePlay'} style={styles.linkButton} />
    </Link>
  </View>
)

const styles = variantProvider.createComponentStyle(
  (theme) => ({
    storeButtonsWrapper: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
    linkButton: {
      width: 150,
      height: 50,
      [Theme.media.down('small')]: {
        width: 140,
        height: 46,
      },
    },
  }),
  true,
)

